export default __webpack_public_path__ + "locales/sk/Webhooks.json?hash=fa0f25cb3105d72b1a9cc913877bd6ee";